import { Component } from '@angular/core';
import { AlertController, IonicPage, LoadingController, NavController, NavParams } from 'ionic-angular';
import { Http } from "@angular/http";
import config from "../../config/config";

/**
 * Generated class for the SiapePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-siape',
  templateUrl: 'siape.html',
})
export class SiapePage {
  usuario: any;
  grupo: any;
  usuarioIdAuditoria: any;
  bemVindo: any;
  comContrato:any;
  porcentagem: any;

  constructor(
    public navCtrl: NavController,
     public navParams: NavParams,
     public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,

     private _http: Http,
     ) {
  }

  ionViewDidLoad() {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });

    loading.present();

    this.usuario = this.navParams.get("usuario");
    console.log(this.usuario)
    this.usuarioIdAuditoria = this.navParams.get("usuarioIdAuditoria");
    this.getUsuarioContratos();
    loading.dismiss(); 

  }
  getUsuarioContratos(){
    this._http
            .get(config.urlAPI + "usuario/comContratos",)
            .map(res => res.json())
            .toPromise()
            .then(res => {
              this.comContrato = res;
            })
            .catch(error => {
              console.log(error);
            });
  }
  GerarArquivoSiape(){
    if (!this.porcentagem) {
      this.porcentagem = '1'
    }
    let env = {
      valor:this.porcentagem
    }

    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
            .post(config.urlAPI + "usuario/siape",env)
            .map(res => res.json())
            .toPromise()
            .then(res => {
   
              var iframe = document.querySelector("#iframe-siape");
              iframe.setAttribute('href','http://146.164.5.73:30180/Sintufrj/backend/public/'+res);
              iframe.setAttribute('download','siape.txt');

              document.getElementById("iframe-siape").click();
              setTimeout(function(){ loading.dismiss(); }, 2000);
            })
            .catch(error => {
              loading.dismiss();
              let alert = this.alertCtrl.create({
                title: "Erro",
                subTitle: "Um Erro inesperado aconteceu",
                buttons: [
                  {
                    text: "ok",
                    handler: data => {
                     
                    }
                  },
                
                ]
              });
              alert.present();
              console.log(error);
            });
  }
}



// WEBPACK FOOTER //
// ./src/pages/siape/siape.ts